module.exports = __webpack_public_path__ + "static/media/bg_monkey_fishing.d9452a2f.png";